import React from "react";
import { EuiIcon } from "@elastic/eui";

export const BooleanCellRenderer = (params: any) => {

  if (params.node.rowPinned) {
    return null;
  }
  
  let iconState = params.value === 1 || params.value;

  const getTrueIcon = () => {
    return (
      <EuiIcon type="check" color="green" size="m" />
    );
  };

  const getFalseIcon = () => {
    return (
      <EuiIcon type="cross" color="red" size="m" />
    );

  };
  
  return iconState ? getTrueIcon() : getFalseIcon();
};
